"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTileBar.default;
  }
});

var _GridListTileBar = _interopRequireDefault(require("./GridListTileBar"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/GridListTileBar/index.js
// module id = 890
// module chunks = 0